export function DataHelpPane() {

    // _rs: Rotate stabilizers independently of the key (useful for bottom row stabs)
    // _rc: Rotate switch cutouts independently of the key
    // _ss: Shift stabilizers (Mainly for 6U off-center). false = Unshifted (default), true = Shifted
    // _so: Skip automatic orientation fix
    //      By default, the plategen will auto-rotate vertically tall switches so that they are treated as wide keys rotated 90deg
    //      Setting _so: true will skip this fix

    return (
        <div>
            <h2>自定义数据</h2>
            <p>定位板生成器提供了一些额外的选项来调整定位板的输出。<br />
                这些选项可以作为 KLE 标记添加到输入的 KLE 数据中，类似于 <code>{`{w:Width}`}</code>。</p>
            <p>例如，要为底部空格键卫星轴添加 <code>_rs: 180</code> 标记以旋转卫星轴，首先找到现有的 <code>w:6.25</code> 或类似空格键修饰符，然后以标准 JSON 格式添加该标记。<br />
                完成后结果应类似于 <code>{`{w:6.25,_rs:180}`}</code>。</p>
            <br />
            <h3>可用的定位板生成器标记</h3>
            <br />
            <h4 style={{ textTransform: "lowercase" }}>_rs</h4>
            <p>值类型：数值</p>
            <p>独立于按键旋转卫星轴，旋转角度由指定值决定。</p>
            <br />
            <h4 style={{ textTransform: "lowercase" }}>_rc</h4>
            <p>值类型：数值</p>
            <p>独立于旋转簇旋转轴体开孔，旋转角度由指定值决定。</p>
            <br />
            <h4 style={{ textTransform: "lowercase" }}>_ss</h4>
            <p>值类型：布尔值</p>
            <p>切换偏移卫星轴以启用偏心的 6U 卫星轴。</p>
            <br />
            <h4 style={{ textTransform: "lowercase" }}>_so</h4>
            <p>值类型：布尔值</p>
            <p>切换自动方向修正。
                默认情况下，当按键高度大于宽度时，定位板生成器会自动旋转轴体开孔并添加卫星轴。
            </p>
        </div>
    )
}

export function SwitchCutoutPane() {

    return (
        <div>
            <h2>轴体开孔类型</h2>
            <br />
            <h4>Cherry MX 标准</h4>
            <p>14 x 14 mm</p>
            <p>现代 MX 类轴体的标准轴体开孔。</p>
            <br />
            <h4>Alps SKCM/L</h4>
            <p>15.5 x 12.8 mm</p>
            <p>适用于 Alps SKCM 和 SKCL 系列轴体。</p>
            <br />
            <h4>Choc CPG1350</h4>
            <p>14 x 14mm</p>
            <p>适用于凯华 Choc V1 CPG1350 轴体，行程 3.0mm。<br />
            开孔尺寸与 Cherry MX 标准相同。</p>
            <br />
            <h4>Mini Choc CPG1232</h4>
            <p>13.7 x 12.7 mm</p>
            <p>适用于凯华 CPG1232 轴体， marketed 为 "Mini Choc"。<br />
                行程为 2.4mm。</p>
            <br />
            <h4>Omron B3G/B3G-S</h4>
            <p>13.5 x 13.5 mm</p>
            <p>适用于 Omron B3G 和 B3G-S 系列轴体。</p>
            <br />
            <h4>Alps SKCP</h4>
            <p>16 x 16 mm</p>
            <p>适用于 Alps SKCP 系列轴体。</p>
            <br />
            <h4>Hi-Tek 725</h4>
            <p>15.621 x 15.621 mm (0.615 in)</p>
            <p>适用于 NMB Hi-Tek 725 轴体。</p>
            <br />
            <h4>i-Rocks</h4>
            <p>15.8 x 13.4 mm</p>
            <p>适用于 i-Rocks 机械轴体。</p>
            <br />
            <h4>Topre RGB</h4>{/* TODO !! */}
            <p></p>
            <p></p>
            <br />
            <h4>Futaba MA</h4>
            <p>14 x 15 mm</p>
            <p>适用于 Futaba MA 机械轴体。</p>   
            <br />
            <h4>静电容 OEM规格/通用款</h4>
            <p>14.6 x 14 mm</p>
            <p>适用于Topre式及兼容的静电容轴体。</p>
            <br />
            <h4>静电容 DynaCap</h4>
            <p>14.7 x 14.1 mm，R角 2.075 mm</p>
            <p>适用于DynaCap静电容轴体。</p>

        </div>
    )
}

export function OtherCutoutPane() {

    return (
        <div>
            <h2>卫星轴开孔类型</h2>
            <br />
            <h4>Cherry MX 标准</h4>
            <p>适用于大多数场景的标准开孔。</p>
            <br />
            <h4>Cherry MX 紧凑</h4>
            <p>更小的开孔，紧密贴合 Cherry MX 规格的卫星轴。<br />
                可能不适配尺寸偏大的第三方卫星轴。</p>
            <br />
            <h4>Cherry MX 规格</h4>
            <p>Cherry MX 数据表中指定的精确卫星轴开孔。<br />
                由于其复杂的形状和紧密的配合，圆角半径应非常小或为 0。</p>
            <br />
            <h4>Alps AEK</h4>
            <p>适用于 Alps AEK 卫星轴尺寸的 Alps 专用卫星轴。</p>
            <br />
            <h4>Alps AT101</h4>
            <p>适用于 Alps AT101 卫星轴尺寸的 Alps 专用卫星轴。</p>
            <br />
             <h4>Topre RGB</h4>{/* TODO !! */}
            <p></p>
            <p></p>
            <br />
            <h4>EC OEM规格/通用款</h4>
            <p>Topre式及兼容静电容轴的卫星轴尺寸规格。</p>
            <br />
            <h4>EC DynaCap</h4>
            <p>DynaCap静电容轴的卫星轴尺寸规格。</p>
            <h2>声学开孔类型</h2>
            <br />
            <h4>Cherry MX 标准</h4>
            <p>适量的声学开孔。</p>
            <br />
            <h4>Cherry MX 极致</h4>
            <p>更多的声学开孔。</p>
        </div>
    )
}

export function AdvancedPane() {

    return (
        <div>
            <h2>高级调整</h2>
            <br />
            <h4>单位尺寸</h4>
            <p>1U 对应的毫米数。<br />
                标准为 19.05mm，但某些轴体（如 Choc）可能需要不同的间距。</p>
            <br />
            <h4>切割补偿</h4>
            <p>用于补偿制造误差的偏移量。适用于激光切割等工艺。<br />
                正值会使开孔变小。</p>
        </div>
    )
}

export function AboutPane() {

    return (
        <div>
            <h2>ai03 定位板生成器</h2>
            <p>最初使用 Python 编写为命令行和服务端工具；现已重写为客户端网页应用。<br />
                目标是为所有键盘制作者提供经过生产验证、极其精确、多功能的定位板生成器。</p>
                <br/>
            <h4>致谢</h4>
            <p>以下人员为本项目提供了帮助和/或信息支持。<br />
                huygn<br />
                jrhe<br />
                fcoury<br />
                Amtra5<br />
                Mxblue<br />
                Bakingpy<br />
                Senter<br />
                Pwner<br />
                Kevinplus</p>
                <br/>
            <h4>贡献</h4>
            <p>请访问<a href="https://github.com/ai03-2725/yet-another-keyboard-builder">源代码仓库</a>了解更多信息。</p>
        </div>
    )
}
